import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { downloadFileFromUrl } from "@utils/fileDownload";
import { WarningPopUp, Image, Anchor } from "hesus-ui-kit";
import deleteIcon from "@icons/ic-delete-red.svg";
import downloadIcon from "@icons/ic-download.svg";
import { ActionButtons } from "../../DocumentList.styled";

const DocumentAction = (props) => {
  const { t, data, onRefreshData } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);

  const [isConfirm, setActionConfirmStatus] = useState(false);

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "DOCUMENT_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "DOCUMENT_CONFIRMATION_BOX_DELETE_CONTENT"
  );

  const handleDocumentStatus = (status) => {
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .delete(`/documents/${data.id}`)
        .then(() => {
          onRefreshData(true);
          setActionConfirmStatus(false);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <ActionButtons>
      <>
        <>
          <Anchor
            clickAction={() =>
              downloadFileFromUrl(data.downloadLink, data.fileName)
            }
          >
            <Image
              src={downloadIcon}
              alt={t("DOCUMENT_ACTION_TOOLTIP_DOWNLOAD")}
              title={t("DOCUMENT_ACTION_TOOLTIP_DOWNLOAD")}
              className="document-list__filter-icon-margin"
            />
          </Anchor>
        </>
        <Image
          src={deleteIcon}
          onClick={() => handleDocumentStatus(0)}
          alt={t("DOCUMENT_ACTION_TOOLTIP_DELETE")}
          title={t("DOCUMENT_ACTION_TOOLTIP_DELETE")}
          className="document-list__filter-icon-margin"
        />
      </>
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ActionButtons>
  );
};

DocumentAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(DocumentAction);
